import { styled } from '@linaria/react';
import { useSpring } from 'react-spring';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  ChildElement,
  SPRING_CONFIGS,
} from './bits';

function Gap() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -20}%)`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 20}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Layer style={{ zIndex: 3, top: 0, ...firstSpring }}>
        <Skew>
          <StyledChildElement>
            <TextWrapper
              style={{ opacity: stepIndex === 2 ? 1 : 0 }}
            ></TextWrapper>
          </StyledChildElement>
          <ChildMargin style={{ height: 50 }} />
        </Skew>
      </Layer>

      <Layer style={{ zIndex: 2, top: 0 }}>
        <Skew>
          <BaseElement />
        </Skew>
        <Label
          orientation="flipped-up"
          isVisible={stepIndex === 2}
          style={{
            bottom: '20%',
            right: '-22%',
          }}
        >
          <div style={{ transform: 'translateX(24px)' }}>
            height: 300px
          </div>
        </Label>
      </Layer>

      <Layer style={{ top: 175, ...secondSpring }}>
        <Skew>
          <BaseMargin style={{ height: 25 }} />
          <BaseElement style={{ height: 121 }}>
            <TextWrapper
              style={{ opacity: stepIndex === 2 ? 1 : 0 }}
            ></TextWrapper>
          </BaseElement>
        </Skew>
      </Layer>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  && {
    height: 365px;
    margin-top: 90px;
  }
`;

const StyledChildElement = styled(ChildElement)`
  height: 64px;
`;

const ChildMargin = styled(BaseMargin)`
  width: calc(100% - 8px);
  margin-left: 4px;
  margin-right: 4px;
`;

const TextWrapper = styled.span`
  transition: opacity 500ms;
`;

export default Gap;
